export default __webpack_public_path__ + "static/media/quiz-white.92903076.svg";